import api from "../API/api";
import { loginFailure, loginStart, loginSuccess, logoutFailure, logoutStart, logoutSuccess } from "./authRedux";

export const login = async (dispatch,loaderRef,alertRef,setAlertMessage,user,navigator,requestedUrl) => {
    
    dispatch(loginStart());

    try{
        const res = await api.post('/users/login',user);
        

        if(res.data.data.login_count === 0){
            console.log('count is zero')
            navigator('/LoginPasswordReset',{state:user})
            return
        } 

        await dispatch(loginSuccess(res.data));

        if(requestedUrl!=null){
            loaderRef.current.toggleState()
            navigator(requestedUrl)
        }else {
            loaderRef.current.toggleState()
            navigator('/home')
        }
        
    }catch(err){
        console.log(err)
        //set state to failed if login not successful
        setAlertMessage('Login Failed')
        loaderRef.current.toggleState()
        alertRef.current.toggleState()
        dispatch(loginFailure())
    }
}



export const logout = async (dispatch,navigator) => {
    
    dispatch(logoutStart());
    try{
        await dispatch(logoutSuccess());
        navigator('/')
    }catch(err){
        //set state to failed if login not successful
        dispatch(logoutFailure())
    }
}